import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Grid,
  GridItem,
  Heading,
  HStack,
  Icon,
  Radio,
  RadioGroup,
  Spacer,
  Switch,
  Tag,
  Text,
} from '@chakra-ui/react';
import { useGlobalContext } from 'GlobalContext';
import { useEffect, useState } from 'react';
import { PiReceipt } from 'react-icons/pi';
import { R$ } from 'shared/helpers/currency';
import { usePermissions } from 'shared/hooks/usePermissions';
import { useAdditionalTaxContext } from './AdditionalTaxContext';

const AdditionalTax = () => {
  const { d } = usePermissions();
  const { confirm } = useGlobalContext();
  const {
    taxes,
    loading,
    isRegistered,
    isClubEnabled,
    handleSubmit,
    handleDisableClub,
    handleChangeValue,
    currentValue,
  } = useAdditionalTaxContext();

  const [isEnabled, setIsEnabled] = useState<boolean>(isClubEnabled);

  useEffect(() => {
    setIsEnabled(isClubEnabled);
  }, [isClubEnabled]);

  const hasNoPermission = d('installation-card-additional_tax-update');
  const isDisabled = !isEnabled || hasNoPermission;

  const handleToggleEnableTax = () => {
    if (!isEnabled) {
      setIsEnabled(true);
      return;
    }

    confirm(
      'Desativar taxa de serviço',
      'Isso desativa o pacote do Clube Yooga na instalação (KDS, motoboy, WhatsApp e zapturbo) e devolve a taxa do PIX ao padrão. Deseja continuar?',
      handleDisableClub,
    );
  };

  return (
    <Card>
      <CardHeader pb="0">
        <HStack justify="space-between">
          <HStack>
            <Icon as={PiReceipt} />
            <Heading size="sm">Taxa de serviço</Heading>
          </HStack>
        </HStack>
      </CardHeader>

      <CardBody>
        {isRegistered ? (
          <>
            <HStack mb="4">
              <Switch
                size="md"
                id="additional-tax-switch"
                isChecked={isEnabled}
                onChange={handleToggleEnableTax}
                isDisabled={hasNoPermission}
              />
              <Text fontWeight="bold">Taxa de serviço</Text>
            </HStack>

            <HStack mb="4">
              <Text fontWeight="bold" mb="2">
                Taxas
              </Text>
            </HStack>

            <RadioGroup
              value={currentValue?.id?.toString()}
              onChange={(nextValue) => {
                const selectedTax = taxes.find(
                  (tax) => tax.id.toString() === nextValue,
                );
                if (selectedTax) {
                  handleChangeValue(selectedTax);
                }
              }}
            >
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                {taxes.map((tax) => {
                  return (
                    <GridItem
                      key={tax.id}
                      backgroundColor="gray.50"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="md"
                      p="4"
                      alignContent="center"
                      cursor={isDisabled ? 'not-allowed' : 'pointer'}
                      opacity={isDisabled ? 0.6 : 1}
                      onClick={() => {
                        if (!isDisabled) {
                          handleChangeValue(tax);
                        }
                      }}
                    >
                      <HStack>
                        <Radio
                          value={tax.id.toString()}
                          isDisabled={isDisabled}
                        />
                        <Text>
                          {tax.type === 'VALUE'
                            ? R$(tax.value)
                            : `${tax.value}%`}
                        </Text>
                        <Spacer />
                        <Tag maxWidth={'20rem'}>{tax.fullDescription}</Tag>
                      </HStack>
                    </GridItem>
                  );
                })}
              </Grid>
            </RadioGroup>
          </>
        ) : (
          <Text fontWeight="500" color="gray.500">
            Nenhuma taxa de serviço encontrada.
          </Text>
        )}

        {isRegistered && (
          <Box mt="6" textAlign="center">
            <Button
              variant="filled"
              size="lg"
              w="100%"
              type="submit"
              isDisabled={isDisabled}
              isLoading={loading}
              onClick={() => handleSubmit(isEnabled)}
            >
              Salvar
            </Button>
          </Box>
        )}
      </CardBody>
    </Card>
  );
};

export default AdditionalTax;
